module.exports = __webpack_public_path__ + "static/media/arabe.577c98d9.png";